import axios from '../axios'

const state = {
    
    status: "",
	statusimg: "",
	summary: {},
	scanlist: {},
	packinginfo: {},
	
	//For tracking, color scheme for route
	color: "",
	colorHex: "",
	colorText: "",
	
	//Popup
	popupData: "",
	
	//For info use...
	curritem: {},
	otheritems: {},
	
};

const getters = {
    scanStatus: state => state.status,
	scanStatusImg: state => state.statusimg,
	scanSummary: state=>state.summary,
	scanList: state=>state.scanlist,
	packingInfo: state=>state.packinginfo,
	color: state=>state.color,
	colorHex: state=>state.colorHex,
	colorText: state=>state.colorText,
	popupData: state=>state.popupData,
	infoCurrItem: state=> state.curritem,
	infoOtherItem: state=> state.otheritems,
	
};

const actions = {
    scanRequest: ({ commit, dispatch }, req) => {
        return new Promise((resolve, reject) => {
            commit('scan_request');
			
			if (req.process == "DELIVERY") {
				
				axios.get('https://new.colorwayrb.com/backend/delivery.php?sessionid=' + localStorage.getItem("sessionid") + "&serial=" + req.item_serial ).then(response => {
				//axios.get("https://new.colorwayrb.com/backend/testpacking.php" ).then(response => {
					console.log(response);
					
					var dispdata = {};
					dispdata.msg = response.data.message;
					dispdata.image = response.data.image; // was empty before
					dispdata.summary = response.data.summary;
					dispdata.scanlist = response.data.scanlist;
					dispdata.color = response.data.color;
					dispdata.colorHex = response.data.colorhex;
					dispdata.colorText = response.data.colortext;
					dispdata.packinginfo = response.data.packing_info;
					dispdata.popupData = response.data.popupdata;
					
					if (response.data.file != null ) {
						if (Array.isArray(response.data.file)) {
							response.data.file.forEach((value, index) => {
								if (value.indexOf("http") > -1) {
									window.open(value, 'WAYBILL' + index);
								} else {
									window.open('https://new.colorwayrb.com/backend/' + value, 'WAYBILL' + index);
								}
							});
						} else {
							window.open('https://new.colorwayrb.com/backend/' + response.data.file, 'WAYBILL');
						}
					}
					
					if (response.data.comminv != null ) {
						if (Array.isArray(response.data.comminv)) {
							response.data.comminv.forEach((value, index) => {
								window.open('https://new.colorwayrb.com/backend/' + value, 'COMMINV' + index);
							});
						} else {
							window.open('https://new.colorwayrb.com/backend/' + response.data.comminv, 'COMMINV');
						}
						
					}
					
					//if (response.data.status == "ERROR") {
						
						//Play sound..
						var audio = new Audio("http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3");
						audio.play();
						
					//}
					
					commit('scan_success', dispdata);
					
				});
				
			}
			else if (req.process == "DELIVERY_BULK") {
				axios.get('https://new.colorwayrb.com/backend/delivery_bulk.php?sessionid=' + localStorage.getItem("sessionid") + "&serial=" + req.item_serial ).then(response => {
					console.log(response);
					
					var dispdata = {};
					dispdata.msg = response.data.message;
					dispdata.image = response.data.image; // was empty before
					dispdata.summary = response.data.summary;
					dispdata.scanlist = response.data.scanlist;
					
					if (response.data.file != null ) {
						if (Array.isArray(response.data.file)) {
							response.data.file.forEach((value, index) => {
								if (value.indexOf("http") > -1) {
									window.open(value, 'WAYBILL' + index);
								} else {
									window.open('https://new.colorwayrb.com/backend/' + value, 'WAYBILL' + index);
								}
							});
						} else {
							window.open('https://new.colorwayrb.com/backend/' + response.data.file, 'WAYBILL');
						}
					}
					
					if (response.data.comminv != null ) {
						if (Array.isArray(response.data.comminv)) {
							response.data.comminv.forEach((value, index) => {
								window.open('https://new.colorwayrb.com/backend/' + value, 'COMMINV' + index);
							});
						} else {
							window.open('https://new.colorwayrb.com/backend/' + response.data.comminv, 'COMMINV');
						}
						
					}
					
					commit('scan_success', dispdata);
					
				});
			}
			else {
				axios.post("https://new.colorwayrb.com/backend/add_track.php?sessionid=" + localStorage.getItem("sessionid") + "&serial=" + req.item_serial, req)
					.then(response => {
						
						var dispdata = {};
						dispdata.msg = response.data.msg;
						dispdata.image = response.data.image; // was empty before
						dispdata.summary = response.data.summary;
						dispdata.scanlist = response.data.scanlist;
						dispdata.color = response.data.color;
						dispdata.colorHex = response.data.colorhex;
						dispdata.colorText = response.data.colortext;
						dispdata.packinginfo = response.data.packing_info;
						
						commit('scan_success', dispdata);
						//resolve(data);
						
						
						
					})
					.catch(err => {
						commit('scan_error', err);
						
						reject(err);
					});
			}
        });
    },
	
	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	infoRequest: ({ commit, dispatch }, req) => {
        return new Promise((resolve, reject) => {
            commit('scan_request');
			
			axios.post("https://new.colorwayrb.com/backend/infoitem.php?sessionid=" + localStorage.getItem("sessionid") + "&item_serial=" + req.item_serial, req)
					.then(response => {
						
						console.log(response);
					
						var dispdata = {};
						dispdata.curritem = response.data.curr;
						dispdata.otheritems = response.data.others; 
						
						commit('scan_info_success', dispdata);
						
						
						
						
					})
					.catch(err => {
						commit('scan_error', err);
						
						reject(err);
					});
			})
	},
  
};

const mutations = {
    scan_request: state => {
        state.status = "loading";
		state.statusimg = "";
    },
    scan_success: (state, payload) => {
        //state.sessionid = payload.sessionid;
        state.status = payload.msg;
		state.statusimg = payload.image;
		state.summary = payload.summary;
		state.scanlist = payload.scanlist;
		state.packinginfo = payload.packinginfo;
		state.colorHex = payload.colorHex;
		state.colorText = payload.colorText;
		state.color = payload.color;
		
    },
	scan_info_success: (state, payload) => {
        //state.sessionid = payload.sessionid;
        state.status = "ok";
		state.curritem = payload.curritem;
		state.otheritems = payload.otheritems;
		
    },
    scan_error: state => {
        state.status = "error - vue error, please contact us.";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};